/**
 * @desc 保存处理企业订单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: any, options?: any) {
  return updateResponse(
    http(URL + `/rpc/omsflow/handlerBusinessOrder`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
